<template>
  <div v-show="showModal" class="modal-upload">
    <div class="modal-contents">
      <slot name="modal-header">
        <div class="w-100 modal-header-content p-2">
          <h3 class="modal-header-text">Uploading files</h3>
        </div>
      </slot>
      <slot name="modal-body">
        <div class="w-100 modal-body-content">
          <div class="w-100 text-center">
            <div class="w-100 process-bar-parent mt-2">
              <div class="process-bar" :style="processStyles" :class="processClass"></div>
            </div>
          </div>
          <div class="w-100 text-center mt-4">
            <h4>
              <small class="custom-font-size" :class="{'text-success': hasUploadFinished, 'text-danger': hasUploadFailed}">
                {{ uploadProgress.text }}
              </small>
            </h4>
          </div>
          <div v-if="hasUploadFinished" class="w-100 text-center text-success">
            <h4>Successfully uploaded files</h4>
          </div>
          <div v-if="errorStatus" class="w-100 text-center text-danger">
            <h4>Error: {{ errorMessage }}</h4>
          </div>
          <div v-if="hasUploadFinished || errorStatus" class="w-100 p-3 mt-2 text-center">
            <button
              class="search-button btn"
              type="button"
              @click="CloseOrGoToDetails()"
            >
              {{ goToDetailsActive ? "View File Tree" : "Close" }}
            </button>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudiesUploadProcessBar',
  props: {
    showModal: Boolean,
    errorStatus: Boolean,
    errorMessage: {
      type: String,
      required: false
    },
    goToDetailsActive: Boolean,
    uploadProgress: Object,
    uploadPercentProgress: Number,
    goToDetails: {
      type: Function,
      required: false
    }
  },
  methods: {
    CloseOrGoToDetails () {
      if (this.goToDetailsActive) {
        this.goToDetails()
      }
      this.$emit('close')
    }
  },
  computed: {
    hasUploadFinished () {
      return this.uploadProgress.status === 'done'
    },
    hasUploadFailed () {
      return this.uploadProgress.status === 'failed'
    },
    processStyles () {
      return {
        width: this.uploadPercentProgress + '% !important',
        height: 100 + '% !important'
      }
    },
    processClass () {
      switch (this.uploadProgress.status) {
        case 'upload':
          return 'process-bar__upload progress-bar-striped'
        case 'validation':
          return 'process-bar__validation progress-bar-striped'
        case 'done':
          return 'process-bar__done'
        case 'failed':
          return 'process-bar__failed'
        default:
          return 'process-bar__upload'
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

@keyframes progress-bar-stripes-animation {
  from { background-position: 20px 0; }
  to { background-position: 0 0; }
}

.modal-upload {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .modal-contents {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 1000px;
    max-height: 400px;
    background-color: rgb(246, 246, 246);
    padding: 1.5rem;

    .modal-header-content {
      border-bottom: 1px solid lightgray;
      .modal-header-text {
        font-size: 30px;
        color: lightslategrey;
      }
    }

    .modal-body-content {
      padding: 1rem 4rem;
      .process-bar-parent {
        border: 1px solid lightgray;
        border-radius: .5rem;
        height: 20px;
        padding: .25rem;
        .process-bar {
          border-radius: .5rem;
          transition: .3s linear;
        }
        .progress-bar-striped {
          background-size: 20px 20px;
          background-image: linear-gradient(45deg, rgba(24, 26, 27, 0.15) 25%, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0) 50%, rgba(24, 26, 27, 0.15) 50%, rgba(24, 26, 27, 0.15) 75%, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0));
        }
        .process-bar__upload {
          background-color: rebeccapurple;
          animation: progress-bar-stripes-animation 1s linear infinite;
        }
        .process-bar__validation {
          background-color: $orange-400;
          animation: progress-bar-stripes-animation 1s linear infinite;
        }
        .process-bar__done {
          background-color: $celery-500
        }
        .process-bar__failed {
          background-color: $red;
        }
      }
      .cancel-btn, .search-button {
        width: 230px;
        height: 48px;
        font-family: 'Open Sans', sans-serif;
        font-size: 16px;
        font-weight: 800;
        line-height: 30px;
        letter-spacing: 0;
        border-radius: 4px;
        color: white;
        text-transform: uppercase;
        transition: background-color 0.2s linear;
      }
      .cancel-btn {
        background-color: $red;
        &:hover {
          background-color: $red-400;
        }
      }
      .search-button {
        background-color: $blueberry;
        &:hover {
          background-color: #9256D9;
        }
      }
    }
  }
}
.custom-font-size {
  font-size: 1em
}

</style>
